<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="8" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt="">下载(带货架商品)</el-button>
        <el-button icon="el-icon-download" @click="exportSelectedJustLiveRooms" alt="">下载(仅直播间)</el-button>
      </el-col>
      <el-col :span="3" >
        <el-input v-model="xposedKeywords"  placeholder="当前无查询关键词"></el-input>
      </el-col>
      <el-col :span="3" >
        <el-button  @click="updateXposedKeyword" alt="">更新关键词</el-button>
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
        background
        @current-change="queryGoodsPage"
        layout="total, prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
        ref="dataTable"
        :data="liveRooms"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期/关键词/小时">
          <template scope="scope">
             {{ scope.row.crawlerVersion }}/{{ scope.row.searchKeyword }} / {{ scope.row.crawlerVersionHour }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="authorDouId" label="直播间信息">
          <template scope="scope">
            房间ID:{{ scope.row.roomId }} <br />
            直播间标题:{{ scope.row.roomTitle }} <br />
            直播地址:{{ scope.row.roomLink }} <br />
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="主播信息">
          <template scope="scope">
            UID:{{ scope.row.userId }} <br />
            快手号:{{ scope.row.kwaiId }} <br />
            昵称:{{ scope.row.userName }} <br />
            企业认证:{{scope.row.userEnterpriseVerify}}<br />
             <a target="blank" :href="scope.row.userHomePageLink">个人主页</a><br />
          </template>
        </el-table-column>
        <el-table-column label="主播头像" width="100">
          <template scope="scope">
            <img
              :src="scope.row.userAvatar"
              width="70"
              height="70"
              class="head_pic"
            />
          </template>
        </el-table-column>
        <el-table-column label="查看货架" width="100">

        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
// const _ = require("lodash");
export default {
  name: "kuaishouLiveRooms",
  data() {
    return {
      liveRooms: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
      xposedKeywords: '',
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=1";

      window.open("/api/kuaishou/export/liverooms?" + para);
    },

    exportSelectedJustLiveRooms() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=0";

      window.open("/api/kuaishou/export/liverooms?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }


      axios
        .get("/api/kuaishou/queryPageLiveRooms?page=" + pageNum + "&pageSize=50" + para)
        .then((content) => {
          if (content.data.status.code === 0) {
            console.log(content.data.data)
            _this.liveRooms = content.data.data.liveRooms;
            _this.totalItems = content.data.data.total;
          }
        });
    },
    getXposedKeywords() {
      const _this = this;
      axios.get("/api/kuaishou/xposed/getKeywords")
          .then((content) => {
            console.log(content)
            if(content.data.status === 0 &&  content.data.data !== 'None') {
              _this.xposedKeywords = content.data.data
            }
          });
    },
    updateXposedKeyword() {
      const _this = this;
      axios.post("/api/kuaishou/xposed/setKeywords",{ keyword: _this.xposedKeywords})
          .then((content) => {
            console.log(content)
            if(content.status === 0 ||  content.data !== 'None') {
              _this.$message({
                type: "success",
                message: "更新成功!",
              });
            }
            _this.getXposedKeywords();
          });

    }
  },
  mounted() {
    this.loadItemInfo(1);
    this.getXposedKeywords();
  },
};
</script>
